<template>
  <path
    fill="currentColor"
    d="M12 0c3.2 6.4 5.6 8.8 12 12-6.4 3.2-8.8 5.6-12 12-3.2-6.4-5.6-8.8-12-12C6.4 8.8 8.8 6.4 12 0Z"
  />
</template>
